import { css } from '@emotion/react';
import { Modal, Type } from '@robinhood/design';

import Button from 'src/components/creditApplication/Button';

interface PropsIface {
  onDismiss: () => void;
}

const VermontModal = ({ onDismiss }: PropsIface) => {
  return (
    <Modal width='wide' overrideModalStyles={root} onClose={onDismiss}>
      <Type.Display size='S' overrideRootStyles={{ textAlign: 'center' }}>
        Vermont lending laws
      </Type.Display>
      <Type.Text size='M' overrideRootStyles={{ textAlign: 'center' }}>
        THIS IS A LOAN SOLICITATION ONLY. ROBINHOOD CREDIT, INC. IS NOT THE LENDER. INFORMATION RECEIVED WILL BE SHARED
        WITH ONE OR MORE THIRD PARTIES IN CONNECTION WITH YOUR LOAN INQUIRY. THE LENDER MAY NOT BE SUBJECT TO ALL
        VERMONT LENDING LAWS. THE LENDER MAY BE SUBJECT TO FEDERAL LENDING LAWS.
      </Type.Text>
      <Button label='Dismiss' width='full' type='button' onClick={onDismiss} />
    </Modal>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`;

export default VermontModal;
